import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../actions/index.types'
import { notify } from '../../../utils/notification'
import webTokenStorer, { selectedSocietyStorer } from '../../../utils/webStorer';
import * as  req from '../../../axios/request/AuthReqs/authReq'
import { getMySocietiesReq, getMyPermissionsReq } from '../../../axios/request/SocietyPortal/RolePermissionReqs/RolePermissionReqs'
import { getCoords, isGeofenceError } from '../../../utils/helpers/geolocation'
// import { getFirebaseURL } from '../../../firebase/firebaseFunction';
function* register(action) {
    try {
        const result = yield call(req.registerReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({ type: types.REGISTER_SUCCESS, payload: result.data });
            action?.data?.clearForm();
        } else {
            yield put({ type: types.REGISTER_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e)
    }
}

function* login(action) {
    try {
        // Capture the device location ONCE and reuse it for both login and the
        // /auth/me call below, so the geofence is evaluated against a single
        // fresh fix (and we never double-prompt for GPS). Employees are blocked
        // at sign-in when outside their society premises.
        const coords = yield call(getCoords);
        const gAction = { ...action, data: { ...(action.data || {}), ...coords } };

        const result = yield call(req.loginReq, gAction);
        // console.log(result)
        if (result.success === true) {
            webTokenStorer.saveToken({
                access_token: result.data.token,
                society_id: result.data?.user?.community_id || 0,
                user_id: result.data?.user?.user_id || 0,
                user_role: result.data.role,
                rememberMe: action.data?.rememberMe || 0,
                is_super_admin: result.data?.user?.is_super_admin || 0,

            })
            const result2 = yield call(req.reloginReq, gAction);
            if (result2.success === true) {
                notify('success', result.message);
                webTokenStorer.saveToken({
                    access_token: result2.data.token,
                    society_id: result2.data?.user?.community_id || 0,
                    user_id: result2.data?.user?.user_id || 0,
                    user_role: result2.data.role,
                    rememberMe: action.data?.rememberMe || 0,
                    is_super_admin: result2.data?.user?.is_super_admin || 0,
                })
                // result.data.default_community.profile_photo_url = yield getFirebaseURL(result.data.default_community?.profile_photo)

                yield put({ type: types.LOGIN_SUCCESS, payload: result.data });
                yield put({ type: types.RELOGIN_SUCCESS, payload: result2?.data });

                // Hydrate societies + permissions for the active society.
                try {
                    const societiesRes = yield call(getMySocietiesReq);
                    if (societiesRes?.success === true) {
                        yield put({ type: types.GET_MY_SOCIETIES_SUCCESS, payload: societiesRes });

                        const persisted = selectedSocietyStorer.getUserSocietydata?.();
                        const list = societiesRes.data || [];
                        // Selection priority (last_society_id FIRST — see note below):
                        //   1. last_society_id — the society the backend remembers for
                        //      this user (recorded automatically from the X-Society-Id
                        //      header we send on every request). A returning user resumes
                        //      here. It can be null (e.g. their access to that society was
                        //      removed) — we simply fall through when that happens.
                        //   2. client-persisted selection (device continuity).
                        //   3. exactly one society — nothing to choose.
                        //   4. primary / first — graceful default for multi-society users
                        //      with nothing remembered.
                        // last_society_id MUST be checked before is_primary, otherwise the
                        // remembered society gets overridden by the primary default.
                        const lastSocietyId =
                            result2?.data?.last_society_id ?? result?.data?.last_society_id ?? null;
                        const remembered = lastSocietyId != null
                            && list.find(s => Number(s.society_id) === Number(lastSocietyId));
                        // The exact membership (society AND role) chosen before — a
                        // member who switched to their committee role stays in it.
                        const persistedExact = persisted?.user_society_id != null
                            && list.find(s => s.user_society_id === persisted.user_society_id);
                        const persistedMatch = persistedExact
                            || (persisted && list.find(s => s.society_id === persisted.society_id));
                        const only = list.length === 1 ? list[0] : null;
                        const primary = list.find(s => s.is_primary);
                        // last_society_id names a society, not a role: keep the
                        // remembered role when it belongs to that same society.
                        const rememberedWithRole = remembered && persistedExact
                            && Number(persistedExact.society_id) === Number(remembered.society_id)
                            ? persistedExact : remembered;
                        const active = rememberedWithRole || persistedMatch || only || primary || list[0] || null;

                        if (active) {
                            selectedSocietyStorer.saveSociety(active);
                            yield put({ type: types.SET_ACTIVE_SOCIETY, data: active });

                            const permsRes = yield call(getMyPermissionsReq, { data: { society_id: active.society_id } });
                            if (permsRes?.success === true) {
                                yield put({ type: types.GET_MY_PERMISSIONS_SUCCESS, payload: permsRes.data });
                            }
                        }
                    }
                } catch (hydrateErr) {
                    console.log('post-login hydrate failed', hydrateErr);
                }
            } else {
                notify('error', result2?.response?.data?.message);
                yield put({ type: types.LOGIN_FAILURE, payload: result.data });
                yield put({ type: types.RELOGIN_FAILURE, payload: result2?.data });

            }
            // yield put({ type: types.LOGIN_SUCCESS, payload: result.data });
            action?.data?.onSuccess();
        } else {
            const status = result?.response?.status;
            const msg = result?.response?.data?.message;
            if (status === 403 && isGeofenceError(msg)) {
                // Blocked by the geofence — surface a retry-with-fresh-GPS state
                // (distinct from a wrong-password error). loginReq already
                // toasted the message; the login page shows a Retry affordance.
                yield put({ type: types.LOGIN_GEOFENCE_BLOCKED, message: msg });
            } else {
                notify('error', msg);
                yield put({ type: types.LOGIN_FAILURE, message: result?.message });
            }
        }
        // // if (result.statusCode === 200) {
        // //     webTokenStorer.saveToken({
        // //         access_token: result.data.access_token,
        // //         society_id: result.data?.default_community?.community_id,
        // //         user_role: result.data.user_role,
        // //         house_unique_id: result.data?.default_community?.blocks?.[0]?.houseUniqueId || 0,
        // //         rememberMe: action.data.rememberMe

        // //     })
        // //     const reloginResult = yield call(req.reloginReq, {
        // //         data: {
        // //             society_id: result.data?.default_community?.community_id,
        // //             house_unique_id: result.data?.default_community?.blocks?.[0]?.houseUniqueId || 0,
        // //             user_role: result.data.user_role,
        // //             firstLogin: true,
        // //             ipAddress: action.data?.ipAddress,
        // //             pwd: result.data.pwd,
        // //         }
        // //     });

        // //     if (reloginResult.statusCode === 200) {
        // //         // reloginResult.data.default_community.profile_photo_url = yield getFirebaseURL(result.data.default_community?.profile_photo)

        // //         webTokenStorer.saveToken({
        // //             access_token: reloginResult.data.access_token,
        // //             society_id: reloginResult.data.default_community?.community_id,
        // //             house_unique_id: reloginResult.data?.default_community?.blocks?.houseUniqueId || 0,
        // //             user_role: reloginResult.data.user_type,
        // //             pwd: reloginResult.data.pwd
        // //             //rememberMe: action.data.rememberMe
        // //         })
        // //         if (action.data.rememberMe)
        // //             webCredentialsStorer.saveCredentials({ id: action.data.email, pwd: action.data.password })

        // //         yield put({ type: types.LOGIN_SUCCESS, payload: reloginResult.data });
        // //         action.data?.onSuccessCallback()
        // //         notify('success', reloginResult.message);
        // //     }
        // //     else {
        // //         webTokenStorer.removeToken()
        // //         yield put({ type: types.LOGIN_FAILURE, message: result?.response?.data?.message });
        // //     }
        // } else {
        //     webTokenStorer.removeToken()
        //     yield put({ type: types.LOGIN_FAILURE, message: result?.response?.data?.message });
        // }
    } catch (e) {
        console.log(e)
    }
}

function* logout(action) {
    try {
        // Record the check-out location (logout is never geofence-blocked).
        const coords = yield call(getCoords);
        const gAction = { ...action, data: { ...(action.data || {}), ...coords } };
        const result = yield call(req.logoutReq, gAction);
        if (result.success === true) {
            webTokenStorer.removeToken()
            selectedSocietyStorer.removeSociety();
            yield put({ type: types.CLEAR_ACTIVE_SOCIETY });
            notify('success', 'Logged out successfully');
            action?.data?.redirect()
            // navigate(SOCIETY_CONTROLLER + LOGIN)
            // result.data.default_community.profile_photo_url = yield getFirebaseURL(result.data.default_community?.profile_photo)

            yield put({ type: types.LOGIN_SUCCESS, payload: '' });
        } else {
            yield put({ type: types.LOGIN_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
    }
}

function* relogin(action) {
    try {
        // /auth/me re-validates employee societies against the geofence — send a
        // fresh fix on session restore too (residents/admins ignore it).
        const coords = yield call(getCoords);
        const gAction = { ...action, data: { ...(action.data || {}), ...coords } };
        const result = yield call(req.reloginReq, gAction);
        if (result.success === true) {
            webTokenStorer.saveToken({
                access_token: result.data.token,
                society_id: result.data?.user?.community_id || 0,
                user_id: result.data?.user?.user_id || 0,
                user_role: result.data.role,
                rememberMe: action.data?.rememberMe || 0,
                is_super_admin: result.data?.user?.is_super_admin || 0,
            })
            action.data?.onSuccessCallback?.()
            // result.data.default_community.profile_photo_url = yield getFirebaseURL(result.data.default_community?.profile_photo)

            yield put({ type: types.RELOGIN_SUCCESS, payload: result.data });

            try {
                const societiesRes = yield call(getMySocietiesReq);
                if (societiesRes?.success === true) {
                    yield put({ type: types.GET_MY_SOCIETIES_SUCCESS, payload: societiesRes });

                    const persisted = selectedSocietyStorer.getUserSocietydata?.();
                    const list = societiesRes.data || [];
                    // Relogin is a session/reload continuation, so the user's current
                    // in-app choice (persisted) wins; last_society_id (result.data is the
                    // /auth/me response) is honoured ahead of the primary/first default so
                    // it never overrides the remembered society.
                    const lastSocietyId = result?.data?.last_society_id ?? null;
                    const remembered = lastSocietyId != null
                        && list.find(s => Number(s.society_id) === Number(lastSocietyId));
                    // Exact membership first (society AND role — see role switch).
                    const persistedMatch = (persisted?.user_society_id != null
                        && list.find(s => s.user_society_id === persisted.user_society_id))
                        || (persisted && list.find(s => s.society_id === persisted.society_id));
                    const only = list.length === 1 ? list[0] : null;
                    const primary = list.find(s => s.is_primary);
                    const active = persistedMatch || remembered || only || primary || list[0] || null;

                    if (active) {
                        selectedSocietyStorer.saveSociety(active);
                        yield put({ type: types.SET_ACTIVE_SOCIETY, data: active });

                        const permsRes = yield call(getMyPermissionsReq, { data: { society_id: active.society_id } });
                        if (permsRes?.success === true) {
                            yield put({ type: types.GET_MY_PERMISSIONS_SUCCESS, payload: permsRes.data });
                        } else {
                            yield put({ type: types.GET_MY_PERMISSIONS_FAILURE, message: permsRes?.message });
                        }
                    } else {
                        // No society to scope permissions to — clear the loading state.
                        yield put({ type: types.GET_MY_PERMISSIONS_FAILURE });
                    }
                } else {
                    yield put({ type: types.GET_MY_PERMISSIONS_FAILURE, message: societiesRes?.message });
                }
            } catch (hydrateErr) {
                console.log('post-relogin hydrate failed', hydrateErr);
                yield put({ type: types.GET_MY_PERMISSIONS_FAILURE, message: hydrateErr?.message });
            }
        } else {
            yield put({ type: types.RELOGIN_FAILURE, message: result?.response?.data?.message });
            // Relogin failed — resolve the permissions loading state so guards don't spin forever.
            yield put({ type: types.GET_MY_PERMISSIONS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_MY_PERMISSIONS_FAILURE, message: e?.message });
    }
}


export default function* loginSaga() {
    yield takeLatest(types.REGISTER, register);
    yield takeLatest(types.LOGIN, login);
    yield takeLatest(types.LOGOUT, logout);
    yield takeLatest(types.RELOGIN, relogin);
}